import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import Table from "./table";
import { paths } from "../../../app_modules";
import AdminHeader from "../../../../widgets/templates/admin_header";

function AcademicConceptsPage(){

    return(
        <MainContent>
            <AdminHeader 
                title="Conceptos académicos" 
                masivPath={paths.academic_concepts_form} 
                createPath={paths.academic_concepts_form} 
            />
            <hr />
            <div style={{ width: '100%' }}>
                <Table />
            </div>
        </MainContent>
    );
}

export default AcademicConceptsPage;